import { Button } from "@/components/ui/button";
import { Check, Loader } from "lucide-react";
import { FormButtonsProps } from "../../relacao-pagamentos.types";

export function FormButtons({ navigate, isValid, isPending, onClose }: FormButtonsProps) {
  const SaveButton = ({ content, icon }: { content: string, icon: React.ReactNode }) => (
    <Button
      type="submit"
      className="bg-emerald-600 hover:bg-emerald-500"
      disabled={!isValid}
    >
      {icon} {content}
    </Button>
  )

  return (
    <div className="flex items-center gap-3 justify-end pt-2">
      <Button
        type="button"
        variant="outline"
        className="border-gray-600 text-gray-300 hover:bg-gray-700/50"
        onClick={() => onClose ? onClose() : navigate("/financeiro/relacao-pagamentos")}
      >
        Cancelar
      </Button>

      <SaveButton
        content={isPending ? "Carregando" : "Salvar"}
        icon={isPending ? <Loader className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
      />
    </div>
  )
}